import { brandColors, defaultOptions, Doughnut } from '.';
import { LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import { merge } from 'lodash';
import { useNavigate } from 'react-router-dom';
import useAlarmTypesStore from 'store/alarm-types';

/**
 * @function AlarmsByType
 * @memberof module:Charts
 * @description Doughnut chart grouping alarms by type
 *
 * @param {object} props
 * @param {object} props.data
 * @param {boolean} props.loading
 * @returns React.Element
 *
 * @example
 * <AlarmsByType data={data} loading={loading} />
 */
function AlarmsByType({data, loading=false, device}) {
  const navigate = useNavigate();
  const [alarmTypesStore] = useAlarmTypesStore();
  return (<>
    {loading ? <LoadingIndicator /> :
      <Doughnut
        options={merge(defaultOptions.doughnut, {
          onClick: (event, array) => {
            const alarmType = alarmTypesStore.types.find(type => type.displayName == data.labels[array[0]?.index]);
            if (!array?.[0]) return;
            if (device.model.type == 'Site') {
              // NOTE - Right now site isn't provided on alarm models but it should be
              // and we should be able to remove this
              navigate(`/alarms?alarmType=${alarmType?.name || data.labels[array[0].index]}`);
            } else {
              navigate(`/alarms?alarmType=${alarmType?.name || data.labels[array[0].index]}&${device.model.type.toLowerCase()}Id=${device.model.id}`);
            }
          },
          plugins: {
            // NOTE - This appears to fix an issue where the donut would initially render
            // without colors after a certain delay in loading. Unclear how long the delay
            // needs to be to break or why this fixes it.
            // https://www.chartjs.org/docs/latest/general/colors.html#dynamic-datasets-at-runtime
            colors: {
              forceOverride: true
            },
            legend: {
              labels: {
                boxWidth: 12,
                boxHeight: 12
              }
            }
          }
        })}
        data={data}
      />
    }
  </>);
}

export default AlarmsByType;
